export default __webpack_public_path__ + "static/media/lfelipe.57f7351c.jpg";